<ng-container *mobxAutorun>
  <lf-app #lfApp [isReadOnly]="isSubmitting">
    <lf-action-bar [actions]="actions"></lf-action-bar>

    <!-- Fields -->
    <div class="lf-app-content">
      <div *ngIf="_lfFileStorage.isLoading" class="lf-loading"></div>
      <div *ngIf="!_lfFileStorage.isLoading">
        <router-outlet></router-outlet>
      </div>
    </div>

    <lf-submit [showResume]="initialValues.mode.new">
    </lf-submit>
  </lf-app>
  <!-- Component containing a modal to show occurring errors -->
  <lf-error-handler></lf-error-handler>

  <!-- Modals to show application's schema and value -->
  <lf-modal #schemaModal size="lg">
    <lf-modal-header>Schema</lf-modal-header>
    <lf-modal-body>
      <pre>{{ _lfStorage.schema() | json }}</pre>
    </lf-modal-body>
  </lf-modal>

  <lf-modal #valueModal size="lg">
    <lf-modal-header>Value</lf-modal-header>
    <lf-modal-body>
      <pre>{{ _lfStorage.getAsJS() | json }}</pre>
    </lf-modal-body>
  </lf-modal>

  <!-- Modal to show application's passed initial values (parameters) -->
  <lf-modal #initialValuesModal size="lg">
    <lf-modal-header>InitialValues</lf-modal-header>
    <lf-modal-body>
      <pre>{{ initialValues | json }}</pre>
    </lf-modal-body>
  </lf-modal>

  <!-- Modal to confirm that the user is aware of the conditions for using OSS -->
  <lf-modal *ngIf=initialValues.mode.new
            #registrationAlert [startVisible]="true"
            [style]="'primary-alt'"
            [closeWithEsc]="false"
            [showCloseButton]="false"
            [ignoreBackdropClick]="true">
    <lf-modal-header data-keyboard="false" class="vcenter">
      <div class="col-xs-9"><lf-i18n key="schemeConditionsTitle"></lf-i18n></div>
      <div class="input-group col-xs-3">
        <select class="form-control" (change)="_lfI18n.setCurrentLanguage($event.target.value)">
          <option *ngFor="let lang of _lfI18n.languages"
                  [value]="lang"
                  [selected]="_lfI18n.currentLanguage === lang">{{_lfI18n.get('AT_ACTIONS_MENU')[lang]}}</option>
        </select>
      </div>
    </lf-modal-header>
    <lf-modal-body>

      <lf-i18n key="schemeConditions"></lf-i18n>
      <lf-checkbox path="non-union-form/meetsConditions"></lf-checkbox>

    </lf-modal-body>

    <lf-modal-footer>
      <button class="btn btn-md btn-secondary" type="button" (click)="redirect('/oss/non-union')">
        <span>
          <lf-i18n key="modalNoBtn"></lf-i18n>
        </span>
      </button>
      <button class="btn btn-md btn-primary" type="button" (click)="registrationAlert.hide()"
              [disabled]="!lfApp.relativeStorage.get('./non-union-form/meetsConditions')">
        <span>
          <lf-i18n key="modalYesBtn"></lf-i18n>
        </span>
      </button>
    </lf-modal-footer>
  </lf-modal>

</ng-container>

